type ProfileDetailItemProps = {
  label: string
  marginBottom?: string
  children: React.ReactNode
}
export default function ProfileDetailItemH5({
  label,
  marginBottom = "17px",
  children,
}: ProfileDetailItemProps) {
  return (
    <div className="detail-item-wrap">
      <div className="detail-item-label">{label}</div>
      <div className="detail-item-value">{children || "--"}</div>
      <style jsx>{`
        .detail-item-wrap {
          margin-bottom: ${marginBottom};
        }
        .detail-item-label {
          font-size: 12px;
          color: #999999;
        }
        .detail-item-value {
          font-size: 14px;
          color: #333333;
          margin-top: 3px;
          line-height: 20px;
          word-break: break-all;
        }
      `}</style>
    </div>
  )
}
